<template>
    <div
        id="app"
        class="relative"
    >
        <the-cookie-notice />

        <router-view />

        <portal-target name="modals" />

        <portal-target
            class="vue-portal-target-dropdowns"
            name="dropdowns"
            multiple
        />
    </div>
</template>

<script>
    import TheCookieNotice from './the-cookie-notice'

    export default {
        components: {
            TheCookieNotice
        }
    }
</script>
